import _ from 'lodash';

function buildAuthorizedMenu(menuItems, routes, permissionFunc) {
	const items = [];

	if (menuItems !== null && menuItems !== undefined) {
		_.each(menuItems, menuItem => {
			const authItem = buildMenuItem(menuItem, routes, permissionFunc);
			if (authItem) {
				items.push(authItem);
			}
		});
	}

	return _.sortBy(items, item => item.order);
}

function buildMenuItem(menuItem, routes, permissionFunc) {
	if (menuItem === null || menuItem === undefined) {
		return null;
	}

	let authorized = hasPermission(menuItem, permissionFunc); // menu auth
	if (authorized) {
		// route auth
		const route = getRouteByMenu(menuItem, routes);
		authorized = route && hasPermission(route, permissionFunc);
	}

	if (authorized) {
		var childItems = buildAuthorizedMenu(menuItem.children, routes, permissionFunc);
		if (childItems && childItems.length > 0) {
			menuItem.children = childItems;
		} else {
			delete menuItem.children;
		}

		return menuItem;
	}

	return null;
}

function getRouteByMenu(menuItem, routes) {
	var route = '';
	if (menuItem.route === 'function') {
		const menuRoute = menuItem.route();
		if (menuRoute === null) return null;

		route = menuRoute.routeName;
	} else {
		route = menuItem.route;
	}

	return _.find(routes, r => r.name === route);
}

function hasPermission(item, permissionFunc) {
	var authorized = true;
	if (item && item.authorization) {
		authorized = permissionFunc(item.authorization);
	}
	return authorized;
}

export default buildAuthorizedMenu;
